import React, { useEffect } from 'react'

const InteractEmbed = ({ id, template, disableCover, redirectHost }) => {

  useEffect(() => {
    if (!document.getElementById("interact_script")) {
      var s = document.createElement("script");
      s.id = "interact_script"
      s.type = "text/javascript"
      s.src = "https://i.tryinteract.com/embed/app.js"
      s.async = true
      s.onload = s.onreadystatechange = () => {
        var rs = s.readyState;
        if (rs) if (rs !== 'complete') if (rs !== 'loaded') return;
        window[id] = new window.InteractApp(); 
        window[id].initialize({ appId: id, width:"800", height: "500", async: true, host: "quiz.tryinteract.com", template: template ? true : false, no_cover: disableCover ? true : false, redirect_host: redirectHost ? true : false });
        window[id].display(); 
      }
      document.body.appendChild(s);
    } else {
      window[id] = new window.InteractApp(); 
      window[id].initialize({ appId: id, width:"800", height: "500", async: true, host: "quiz.tryinteract.com", template: template ? true : false, no_cover: disableCover ? true : false, redirect_host: redirectHost ? true : false });
      window[id].display(); 
    }

    return () => {
      window[id] = undefined
    }
  })

  return (
    <div id={ `interact-${ id }` }></div>
  )
}

export default InteractEmbed
